import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["name", "disabled"]
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    name: _ctx.name,
    class: _normalizeClass(`button ${_ctx.classButton}`),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.callFunc && _ctx.callFunc(...args))),
    disabled: _ctx.isDisabled
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`icon ${_ctx.icon.class}`)
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(`${_ctx.icon.name}`)
          }, null, 2)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.value), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}